const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapfre(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 800 400",
    style: {
      enableBackground: "new 0 0 800 400"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E40520"
    },
    d: "M408.3,10.3c61.7,0,111.8,50,111.8,111.8c0,61.7-50,111.8-111.8,111.8c-61.7,0-111.8-50-111.8-111.8 C296.5,60.4,346.5,10.3,408.3,10.3L408.3,10.3z M408.3,21c-55.8,0-101.1,45.3-101.1,101.1c0,55.8,45.3,101.1,101.1,101.1 s101.1-45.3,101.1-101.1C509.4,66.3,464.1,21,408.3,21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E40520"
    },
    d: "M413.8,143.8V178h-11v-34.3c-5.2,0-12.1,0-14.7-0.1l-36.4,0.1c-3.1,0.2-6.2-0.5-9.1-2.2 c-5.5-3.2-8.5-9.1-8.3-15c0-0.9,0.1-1.6,0.2-2.3c1.3-7.2,3.8-14.4,7.7-21.1c3.9-6.7,8.8-12.6,14.5-17.3c3.8-2.8,9.1-4.2,14-3.4 c1.4-4.7,4.6-8.5,8.9-10.7c0.8-0.5,1.6-0.8,2.2-1c8.2-3,17.1-4.6,26.4-4.6c9.3,0,18.2,1.6,26.5,4.6c4.8,2.1,9,6.4,10.8,11.6 c4.7-1.1,9.5,0,13.3,2.9c5.7,4.8,11.4,11.2,15.3,17.9c3.9,6.7,6.4,13.9,7.7,21.1c0.1,0.6,0.2,1.4,0.2,2.3c0.2,5.9-2.7,11.8-8.3,15 c-2.9,1.6-6,2.3-9.1,2.2l-36.4-0.1C425.8,143.7,419,143.8,413.8,143.8L413.8,143.8z M452.5,94.1c-1.7-1.3-4.2-1.5-6.2-0.4 c-1.1,0.6-1.8,1.5-2.3,2.5l-18.4,32.1c-0.6,0.8-0.6,2-0.1,2.9c0.6,1,1.6,1.5,2.6,1.4l37,0.1c1.1,0.1,2.2-0.1,3.3-0.7 c1.9-1.1,2.9-3.2,2.8-5.3c0-0.1,0-0.3,0-0.5c-1.1-6-3.2-11.9-6.4-17.5c-3.2-5.6-7.4-10.4-12.1-14.4 C452.6,94.2,452.5,94.2,452.5,94.1L452.5,94.1z M364.1,94.1c-0.1,0-0.1,0.1-0.2,0.1c-4.7,3.9-8.8,8.8-12.1,14.4 c-3.2,5.6-5.3,11.5-6.4,17.5c0,0.2,0,0.4,0,0.5c-0.2,2.1,0.8,4.2,2.8,5.3c1,0.6,2.2,0.8,3.3,0.7l37-0.1c1,0.1,2.1-0.4,2.6-1.4 c0.5-0.9,0.5-2.1-0.1-2.9l-18.4-32.1c-0.5-1-1.2-1.9-2.3-2.5C368.2,92.6,365.8,92.8,364.1,94.1L364.1,94.1z M431.3,81.2 c-0.1,0-0.2-0.1-0.3-0.1c-7.1-2.6-14.8-4-22.7-4c-7.9,0-15.6,1.4-22.6,4c-0.3,0.1-0.4,0.2-0.6,0.3c-2.3,1.1-3.9,3.5-3.9,6.2 c0,1.5,0.5,2.8,1.2,3.9l22.8,39.3c0.5,1.2,1.7,2,3.1,2c1.3,0,2.5-0.8,3.1-1.9l22.9-39.4c0.8-1.1,1.3-2.5,1.3-4 C435.5,84.7,433.7,82.3,431.3,81.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E40520"
    },
    points: "50.3,275.9 77.6,331.8 104.9,275.9 146.1,275.9 146.1,387.7 104.9,387.7 104.9,331.8 77.6,387.7  50.3,331.8 50.3,387.7 9,387.7 9,275.9  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E40520"
    },
    d: "M227.9,292.6L211.2,351h33.5L227.9,292.6L227.9,292.6z M159.4,387.7l32.1-111.8h72.9l32.1,111.8h-41.3 l-5.3-18.3h-44l-5.3,18.3H159.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E40520"
    },
    d: "M360.6,288.7c9.3,0,18.3,5,18.3,15.1c0,10.1-8,18.3-18.3,18.3h-9v-33.4H360.6L360.6,288.7z M386.9,275.9h-77.2 v111.7h41.3v-46.6h36c18,0,32.6-14.6,32.6-32.6C419.5,290.5,404.9,275.9,386.9,275.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E40520"
    },
    points: "433.8,275.9 543.5,275.9 543.5,294.2 475.1,294.2 475.1,322.7 543.5,322.7 543.5,341 475.1,341  475.1,387.7 433.8,387.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E40520"
    },
    points: "724.5,369.3 793,369.3 793,387.7 683.3,387.7 683.3,275.9 793,275.9 793,294.2 724.5,294.2  724.5,322.7 793,322.7 793,341 724.5,341  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E40520"
    },
    d: "M608.9,288.8c9.1,0,18.3,5,18.3,15.1c0,10.1-8.2,18.3-18.3,18.3h-8.9v-33.4H608.9L608.9,288.8z M667.8,358.8 v0.9C667.8,359.4,667.8,359.1,667.8,358.8L667.8,358.8z M667.8,359.7c0-0.3,0-0.6,0-0.9c-0.5-15-12.8-27-27.9-27 c15.4,0,27.9-12.5,27.9-27.9c0-15.4-12.5-27.9-27.9-27.9h-36H558v55.9v55.9l42,0v-46.3h8.9c10.1,0,18.3,8.2,18.3,18.3 c0,0.3,0,0.6,0,0.9v27h12.7h27.9V359.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapfre);
export default __webpack_public_path__ + "static/media/MAPFRE.c265df5b73c8f51dd89fc8787333e393.svg";
export { ForwardRef as ReactComponent };